const attachmentSwitching = (lang, ar, en) => {
  if (lang === 'ar-EG') return ar
  else return en ?? ar
}
export default attachmentSwitching
